import { safeDefine } from './utils/define';
import { RsMap } from './components/rs-map';


// En dev, registramos directamente para probar en el navegador
safeDefine(RsMap.tag, RsMap);
